<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        enctype="multipart/form-data"
        :data-url="
          selectedUrl
            ? `/accreditations/process/evaluationTestified/${inputs.id}`
            : `/accreditations/process/evaluationTestified`
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group text-center">
              <p class="card-title m-0"><strong>Plan de Evaluación</strong></p>
              <br />
              <a
                :href="inputs.full_url"
                class="btn btn-success btn-md"
                target="_blank"
                @click="saveFile(inputs.full_path)"
              >
                <app-icon name="file" />
              </a>
              <br /><br />
            </div>
          </div>
        </div>

        <div class="form-group row text-center">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">Aprueba el Plan de Evaluación?</h5>
            <br />
          </label>
          <app-input
            id="inputs_approved"
            class="col-sm-12"
            type="radio-buttons"
            :list="listOptions"
            @input="clicked"
            v-model="inputs.approved"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="!hide">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">
              Justificación del rechazo del Plan de Evaluación
            </h5>
          </label>
          <app-input
            id="inputs_observations"
            class="col-sm-12"
            type="textarea"
            v-model="inputs.observations"
            :required="true"
          />
        </div>
        <!-- <div class="row" v-if="hide">
                    <div class="col-12">
                        <div class="form-group">
                            <app-note class="pt-2 clearfix" title="INSTRUCCIONES" content-type="html" note-type="note-warning"
                            :notes="[$t('DESCARGAR EL ARCHIVO PLAN DE EVALUACIÓN, FIRMARLO ELECTRÓNICAMENTE Y LUEGO ADJUNTARLO.')]" />
                            <br><br>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="hide">
                    <div class="col-12">
                        <div class="form-group">
                                <p class="card-title m-0"><strong>Subir Plan de Evaluación Firmado</strong></p>
                                <br>
                                <app-input type="file"
                                        :label="file"
                                        v-model="inputs.attach_accepted"
                                        v-on:change="fileChoosen"
                                        :required="true"
                                />
                            <br><br>
                        </div>
                    </div>
                </div> -->
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApprovedEvaluationModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        observations: null,
      },
      hide: true,
      file: "Seleccionar Archivo",
      modalId: "approved-eval-id-modal",
      modalTitle: this.$t("add"),
      listOptions: [
        {
          id: "2",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.modalTitle = this.$t("Aceptar u Objetar Equipo");
  },
  methods: {
    clicked(event) {
      if (this.inputs.approved === "2") {
        this.hide = false;
      } else {
        this.hide = true;
      }
    },
    fileChoosen(event) {
      if (event.target.files[0].type === "application/pdf") {
        if (event.target.files[0].size < 2111775) {
          this.file = event.target.files[0].name;
        } else {
          this.$toastr.e("El archivo PDF no debe exceder los 2MB.");
        }
      } else {
        this.$toastr.e("Solo permitidos archivos .pdf");
      }
    },
    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      if (this.inputs.approved === "1" && !this.inputs.attach_accepted) {
        // this.$toastr.e("El archivo es obligatorio.");
        // return;
      } else if (this.inputs.approved === "2" && !this.inputs.observations) {
        this.$toastr.e("Las observaciones son obligatorias.");
        return;
      }
      this.createOrUpdate(formData);
    },
    afterSuccess(response) {
      if (response.status == 200) {
        this.$toastr.s("Registro actualizado exitosamente.");
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    createOrUpdate(data) {
      this.preloader = true;
      this.axiosPost({
        url: "/accreditations/process/evaluationTestified",
        data,
      }).then((res) => {
        this.closeModal();
        if (res.status == 200) {
          this.$toastr.s(this.$t("updated_success"));
          this.$hub.$emit("reload-" + this.tableId);
        } else {
          this.$toastr.e(this.$t("Error al intentar actualizar el registro"));
        }
        this.preloader = false;
      });
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.inputs.sampling_plan = null;
      if (this.inputs.sampling_plan_file) {
        this.inputs.sampling_plan = this.inputs.sampling_plan_file.full_url;
      }
      this.inputs.full_url = this.inputs.evaluation_plan_report.full_url;
      this.inputs.full_path = this.inputs.evaluation_plan_report.path;
      this.inputs.approved = "1";
      this.preloader = false;
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    saveFile(file) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.inputs.id;
      info['path'] = String(file);
      this.$store.dispatch("registerFileLog", info);
    },
  },
};
</script>
